import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const Calendar2Fill = (props: IconProps) => {
    const { color = "#000", ...rest } = props

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_10103_6479)">
                <path d="M11.3359 1.99984H14.0026C14.1794 1.99984 14.349 2.07008 14.474 2.1951C14.599 2.32012 14.6693 2.48969 14.6693 2.6665V13.3332C14.6693 13.51 14.599 13.6796 14.474 13.8046C14.349 13.9296 14.1794 13.9998 14.0026 13.9998H2.0026C1.82579 13.9998 1.65622 13.9296 1.5312 13.8046C1.40618 13.6796 1.33594 13.51 1.33594 13.3332V2.6665C1.33594 2.48969 1.40618 2.32012 1.5312 2.1951C1.65622 2.07008 1.82579 1.99984 2.0026 1.99984H4.66927V0.666504H6.0026V1.99984H10.0026V0.666504H11.3359V1.99984ZM2.66927 5.99984V12.6665H13.3359V5.99984H2.66927ZM4.0026 7.33317H5.33594V8.6665H4.0026V7.33317ZM7.33594 7.33317H8.66927V8.6665H7.33594V7.33317ZM10.6693 7.33317H12.0026V8.6665H10.6693V7.33317Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_10103_6479">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>

    )
}

export default Calendar2Fill